<template>
  <FaLayer v-tooltip="tooltip">
    <FaIcon
      :class="{
        ['IconColor IconColor--' + selectedIcon.color]: selectedIcon.color,
        [selectedIcon.class]: selectedIcon.class
      }"
      :mask="selectedIcon.mask || null"
      :icon="selectedIcon.icon"
      :transform="selectedIcon.transform || null"
      :opacity="selectedIcon.opacity || null"
      :style="statusConfig.style || null"
    />
    <FaIcon
      :class="{
        ['IconColor IconColor--' + selectedIcon.subColor]: selectedIcon.subColor,
        ['IconColor IconColor--' + selectedIcon.color]: !selectedIcon.subColor,
        [selectedIcon.subClass]: selectedIcon.subClass
      }"
      :icon="statusConfig.subIcon"
      :mask="(statusConfig.subMask && ['fas', statusConfig.subMask]) || null"
      :transform="statusConfig.subTransform || null"
      :opacity="statusConfig.subOpacity || null"
      :style="statusConfig.subStyle || null"
      v-if="statusConfig.subIcon"
    />
  </FaLayer>
</template>

<script lang="ts">
import { getDeviceInventoryIcon } from '@/overrides/brands/shared/utilities/get-device-inventory-icon';
import { FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import { DEVICE_SIO_DEFAULT_ICON } from '@/constants/device';
import { isArray } from '@/functions/array';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    status: {
      required: false,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: undefined
    },
    connectionStatus: {
      type: String,
      required: false
    },
    state: {
      type: String,
      required: false
    },
    // DEV NOTE :: not currently used... intent is to differentiate between onboard, network, and serial SIO
    type: {
      type: String,
      required: false
    },
    deviceMake: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
    FaLayer: FontAwesomeLayers
  },
  computed: {
    // get information about the icon status
    statusConfig() {
      const { state, disabled, connectionStatus, type, deviceMake } = this;
      // All status handling (including synthetic statuses) is in getDeviceInventoryIcon
      return getDeviceInventoryIcon(connectionStatus, state, deviceMake);
    },
    // build icon details
    icon() {
      const { statusConfig } = this;
      let icon = ['fas', DEVICE_SIO_DEFAULT_ICON];
      if (!statusConfig) return icon;

      icon = (isArray(statusConfig.icon) && statusConfig.icon) || ['fas', statusConfig.icon];

      return icon;
    },
    mask() {
      const { statusConfig } = this;
      let mask = null;
      if (statusConfig.mask) mask = (isArray(statusConfig.mask) && statusConfig.mask) || ['fas', statusConfig.mask];
      return mask;
    },

    // define icon and tooltip
    selectedIcon() {
      const { icon, mask, statusConfig, status } = this;
      const reversedIcon = statusConfig.mask;

      return {
        ...statusConfig,
        color: statusConfig.color || null,
        icon: !reversedIcon ? icon : mask,
        mask: !reversedIcon ? mask : icon,
        value: status
      };
    },
    tooltip() {
      if (!this.selectedIcon?.tooltip) return false;
      return {
        triggers: ['click', 'hover', 'focus'],
        content: `${this.selectedIcon.tooltip}`
      };
    }
  }
});
</script>
